const isPlayable = (activity_key) =>
  activity_key === "music" ||
  activity_key === "art" ||
  activity_key === "dance";

export default isPlayable;
